import CallMadeIcon from '@mui/icons-material/CallMade';
import CallMissedIcon from '@mui/icons-material/CallMissed';
import CallMissedOutgoingIcon from '@mui/icons-material/CallMissedOutgoing';
import CallReceived from '@mui/icons-material/CallReceived';
import GraphicEq from '@mui/icons-material/GraphicEq';
import HistoryOutlineOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MessageIcon from '@mui/icons-material/Message';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import VoicemailIcon from '@mui/icons-material/Voicemail';
import { Box, IconButton, Menu, MenuItem, Theme, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  GridRenderCellParams,
  GridSortModel,
  GridValueFormatterParams,
} from '@mui/x-data-grid';
import clsx from 'clsx';
import { DateTime } from 'luxon';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import moment from 'moment';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';

import { secondsDecimalFormatter } from '../../../common/helperFunctions/minuteFormatter';
import { isPayPerAgent } from '../../../common/isPayPerAgent';
import CrmIcon from '../../../images/crm-icon.svg';
import {
  IBusinessModel,
  IUserAtom,
  Role,
  user,
} from '../../../recoil/atoms/user';
import { callHistoryAdmin2 } from '../../../recoil/selectors/callHistoryAdmin2';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import {
  canAccessCallTranscriptionProduct as canAccessCallTranscriptionPd,
  IPermissions,
  permissionsSelector,
} from '../../../recoil/selectors/permissionsSelector';
import {
  endpointEnum,
  makeAPIRequest,
  makeApiRequestCached,
} from '../../../services/rest/makeAPIRequest';
import CallTranscriptionModal from '../../components/modals/CallTranscriptionModal';
import { EventTrailModal } from '../../components/modals/EventTrailModal';
import HistoryExportModal from '../../components/modals/HistoryExportModal';
import { ModalWithStyles } from '../../components/modals/ModalWithStyles';
import { useSnackbarWithStyles } from '../../components/notifications/SnackbarProviderWithStyles';
import {
  DataTable,
  IColDef,
  IToolbarComponent,
} from '../../modules/Manage/pages/queues-table/DataTable';
import {
  toggleIsPlaying,
  updateMillisecond,
} from '../../store/callTranscriptionSlice';
import { updateDisplayLargeTableMsg } from '../../store/largeTableSlice';
import { EnhancedTableToolbar } from '../Manage/pages/queues-table/EnhancedTableToolbar';

const useStyles = makeStyles((theme: Theme) => ({
  fullWidth: {
    width: '100% !important',
  },
  callMadeIcon: {
    color: '#26c281',
  },
  playIcon: {
    color: '#e87e04',
    marginRight: theme.spacing(1),
  },
  playIcon2: {
    marginRight: theme.spacing(1),
  },
  callMissedIcon: {
    color: '#d91e18',
  },
  messageIcon: {
    color: '#0098C7',
    marginRight: theme.spacing(1),
  },
  linkIcon: {
    color: '#337ab7',
    marginRight: theme.spacing(1),
  },
  phoneNumber: {
    '& .historyc2c.link.pointer': {
      display: 'block',
    },
  },
  audio: {
    transition: 'all 0.5s linear',
    boxShadow: '0px 0px 0px 0px',
    backgroundColor: '#f0f3f4',
    borderRadius: '7px 7px 7px 7px',
    height: 32,
    maxWidth: '-webkit-fill-available',
    margin: '0px auto',
    '&:focus': {
      outline: 0,
    },
  },
  audioContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  audioDetails: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    paddingLeft: '35px',
  },
  audioBullet: {
    width: '50%',
  },
  typeColumn: {
    minWidth: '115px !important',
    maxWidth: '115px !important',
    '&.MuiDataGrid-cell': {
      wordBreak: 'keep-all !important',
    },
  },
  dropdownOverflow: {
    overflow: 'visible !important',
    '.dropdown': {
      zIndex: 10,
    },
  },
  actionsDropdown: {
    borderRadius: 50,
  },
  dropdownToggle: {
    background: 'transparent !important',
    border: 0,
    '&:after': {
      color: '#000 !important',
      margin: '0 !important',
    },
  },
  dropdownButton: {
    borderRadius: '0 !important',
    fontSize: 14,
    color: theme?.palette?.mode === 'dark' ? '#fff' : '#000',
    width: '100%',
    textAlign: 'left',
    padding: '5px 10px',
    '& .MuiIconButton-label': {
      display: 'block !important',
    },
  },
  auditTrail: {
    marginRight: theme.spacing(1),
  },
}));
const renderCell = (params: GridRenderCellParams) => (
  <div dangerouslySetInnerHTML={{ __html: params.value as string }}></div>
);

interface RecordingModalInfo {
  recordingUrl: string;
  agent: string;
  callId: string;
  callType: string;
  callDate: string;
  callXd?: string;
}
// TODO find out why es is not removing recordingurl
// for now removing recording url in frontend
export const twoParty = [
  '209',
  '213',
  '279',
  '310',
  '323',
  '341',
  '408',
  '415',
  '424',
  '442',
  '510',
  '530',
  '559',
  '562',
  '619',
  '626',
  '628',
  '650',
  '657',
  '661',
  '669',
  '707',
  '714',
  '747',
  '760',
  '805',
  '818',
  '820',
  '831',
  '840',
  '858',
  '909',
  '916',
  '925',
  '949',
  '951',
  '203',
  '475',
  '860',
  '959',
  '302',
  '239',
  '305',
  '321',
  '324',
  '352',
  '386',
  '407',
  '448',
  '561',
  '645',
  '656',
  '689',
  '727',
  '728',
  '754',
  '772',
  '786',
  '813',
  '850',
  '863',
  '904',
  '941',
  '954',
  '217',
  '224',
  '309',
  '312',
  '331',
  '447',
  '464',
  '618',
  '630',
  '708',
  '730',
  '773',
  '779',
  '815',
  '847',
  '861',
  '872',
  '227',
  '240',
  '301',
  '410',
  '443',
  '667',
  '339',
  '351',
  '413',
  '508',
  '617',
  '774',
  '781',
  '857',
  '978',
  '406',
  '702',
  '725',
  '775',
  '603',
  '215',
  '223',
  '267',
  '272',
  '412',
  '445',
  '484',
  '570',
  '582',
  '610',
  '717',
  '724',
  '814',
  '835',
  '878',
  '206',
  '253',
  '360',
  '425',
  '509',
  '564',
  '231',
  '248',
  '269',
  '313',
  '517',
  '586',
  '616',
  '679',
  '734',
  '810',
  '906',
  '947',
  '989',
];

export const VoicemailModal = (props: {
  openVoicemailModal: boolean;
  handleCloseVoicemailModal: () => void;
  classes: any;
  voiceMailInfo: RecordingModalInfo;
  businessId: string | number;
}) => {
  if (!props?.businessId || !props?.voiceMailInfo?.callXd) {
    return null;
  }

  const {
    openVoicemailModal,
    handleCloseVoicemailModal,
    classes,
    voiceMailInfo,
    businessId,
  } = props;

  const url = endpointEnum.GET_VM_TRANSCRIPTION.replace(
    '{businessId}',
    businessId.toString()
  ).replace('{callXd}', voiceMailInfo.callXd as string);

  const voicemailSummaryLoadable = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: url,
      stage: 'itn',
      method: 'GET',
      domain: process.env.VITE_APP_CDK_DOMAIN,
    })
  );

  const vMTranscription = useMemo(
    () =>
      voicemailSummaryLoadable?.state === 'hasValue'
        ? voicemailSummaryLoadable?.contents?.response?.data?.text
        : '',
    [voicemailSummaryLoadable]
  );

  return (
    <ModalWithStyles
      show={openVoicemailModal}
      onHide={handleCloseVoicemailModal}
      title="Voicemail Audio"
      size="xs"
      submitLabel=""
    >
      <Box className={classes.audioContainer}>
        <div className={classes.audioDetails}>
          <p className={classes.audioBullet}>
            Agent: <strong>{voiceMailInfo.agent}</strong>
          </p>
          <p className={classes.audioBullet}>
            Call ID: <strong>{voiceMailInfo.callId}</strong>
          </p>
          <p className={classes.audioBullet}>
            Call Type: <strong>{voiceMailInfo.callType}</strong>
          </p>
          <p className={classes.audioBullet}>
            Date: <strong>{voiceMailInfo.callDate}</strong>
          </p>
        </div>
        <div>
          {vMTranscription !== '' && (
            <div style={{ margin: '8px 24px 16px' }}>
              Transcription: <strong>{vMTranscription}</strong>
            </div>
          )}
        </div>
        <audio
          controls
          src={voiceMailInfo.recordingUrl}
          className={classes.audio}
        >
          Your browser does not support the audio element.
        </audio>
      </Box>
    </ModalWithStyles>
  );
};

export const CallHistory = ({ agentId }: { agentId: any }) => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const userLoadable = useRecoilValueLoadable(user);
  const { tier } = userLoadable.contents as IUserAtom;
  const permissionsLoadable = useRecoilValueLoadable(permissionsSelector);
  const {
    role,
    callRecord,
    isBusinessEligibleToAccessCallTranscriptions,
    canDownloadHistory,
  } = permissionsLoadable.contents as IPermissions;
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(20);
  const [search, setSearch] = useState<string>('');
  const [openRecordingModal, setOpenRecordingModal] = useState(false);
  const [openVoicemailModal, setOpenVoicemailModal] = useState(false);
  const [callXd, setCallXd] = useState('');
  const [callId, setCallId] = useState('');
  const [callConfId, setCallConfId] = useState('');
  const [callType, setCallType] = useState<string>('');
  const [callDate, setCallDate] = useState('');
  const [openCallTranscriptionModal, setOpenCallTranscriptionModal] = useState(
    false
  );
  const handleOpenRecordingModal = () => setOpenRecordingModal(true);
  const handleOpenVoicemailModal = () => setOpenVoicemailModal(true);
  const handleOpenCallTranscriptionModal = () =>
    setOpenCallTranscriptionModal(true);
  // const handleCloseCallTranscriptionModal = () => setOpenCallTranscriptionModal(false);
  const handleCloseRecordingModal = () => setOpenRecordingModal(false);
  const handleCloseVoicemailModal = () => setOpenVoicemailModal(false);
  const [recordingInfo, setRecordingInfo] = useState<RecordingModalInfo>({
    recordingUrl: '',
    agent: '',
    callId: '',
    callDate: '',
    callType: '',
  });
  const [voiceMailInfo, setVoicemailInfo] = useState<RecordingModalInfo>({
    recordingUrl: '',
    agent: '',
    callId: '',
    callDate: '',
    callType: '',
    callXd: '',
  });
  const [sortModel, setGridSortModel] = useState<GridSortModel>([
    {
      field: 'phpcallstring',
      sort: 'desc',
    },
  ]);
  const [showExportModal, setShowExportModal] = useState<boolean>(false);
  const [csvProps, setCsvProps] = useState<any>({});
  const userAtomContents = userLoadable.contents as IUserAtom;
  const dispatch = useDispatch();
  const [transcriptionUrl, setTranscriptionUrl] = useState<string>('');
  const [fromLink, setFromLink] = useState<boolean>(false);

  const [openEventTrailModal, setOpenEventTrailModal] = useState(false);
  const handleOpenEventTrailModal = () => setOpenEventTrailModal(true);
  const handleCloseEventTrailModal = () => setOpenEventTrailModal(false);
  const isAdminOrManager =
    role === Role.SUPERADMIN || role === Role.MANAGER || role === Role.ADMIN;

  const canDownloadHistoryBoolean = useMemo(
    () => isAdminOrManager && canDownloadHistory,
    [isAdminOrManager, canDownloadHistory]
  );
  /**
   * Reset page start on search
   *c
   * @param value Search string
   */
  const handleSearchChange = useCallback(
    (value: string) => {
      // reset page back to 1
      setPage(1);
      setSearch(value);
    },
    [setSearch]
  );

  useEffect(() => {
    for (const [key, value] of new URLSearchParams(location.search).entries()) {
      if (key === 'transcription' && value) {
        setCallXd(value);
        setOpenCallTranscriptionModal(true);
        setSearch(value);
        setFromLink(true);
      }
    }
  }, [location]);
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();
  const handleClickSendSMS = (event: any, url: string) => {
    if (isPayPerAgent()) {
      event.preventDefault();
      enqueueSnackbarWithStyles({
        message:
          'You do not have access to send sms messages. Please reach out to your account administrator to upgrade your access',
        alertProps: {
          severity: 'error',
        },
      });
    }
  };
  const [businessDataCached, businessDataLoadable] = makeApiRequestCached<
    IBusinessModel | undefined
  >(
    {
      endpoint: endpointEnum.GET_BUSINESS_DATA,
      payloadJsonString: JSON.stringify({
        call: methodNameEnum.GET_BUSINESS_DATA,
      }),
    },
    (loadable, cached) =>
      loadable.contents?.response?.data?.result?.[0] ?? cached.current
  );
  const businessUsersLoadable = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: endpointEnum.GET_BUSINESS_USERS,
      payloadJsonString: JSON.stringify({
        call: methodNameEnum.GET_BUSINESS_USERS,
      }),
    })
  );
  const callHistory = useRecoilValueLoadable<any>(
    callHistoryAdmin2({
      page,
      pageSize,
      sortModel: {
        ...sortModel?.[0],
      },
      search,
      agentId,
      superadmin: role === Role.SUPERADMIN,
    })
  );
  const externalIds = useMemo(
    () =>
      callHistory.state === 'hasValue'
        ? callHistory?.contents?.data?.calls?.map((el) => {
            if (
              (permissionsLoadable.contents as IPermissions)?.role === Role.USER
            ) {
              if (Number(el?.calluserid) === Number(userAtomContents?.userid)) {
                return el?.externalid;
              }
            } else {
              return el?.externalid;
            }
          })
        : [],
    [callHistory]
  );
  React.useEffect(() => {
    if (fromLink && callHistory?.state === 'hasValue') {
      const currentCall = callHistory?.contents?.data?.calls?.find(
        (call) => call?.externalid === callXd
      );
      if (currentCall) {
        setCallDate(
          currentCall?.phpcalldate2.slice(
            currentCall?.phpcalldate2.indexOf('>') + 1,
            currentCall?.phpcalldate2.lastIndexOf('<')
          )
        );
        setCallType(currentCall?.calltype);
        setTranscriptionUrl(currentCall?.recordingurl);
      }
    }
  }, [fromLink, callHistory]);

  const resetLinkState = () => {
    if (fromLink) {
      setCallXd('');
      setSearch('');
      setFromLink(false);
      setTranscriptionUrl('');
      setCallDate('');
      setCallType('');
      const queryParams = new URLSearchParams(location.search);
      if (queryParams.has('transcription')) {
        queryParams.delete('transcription');
        history.replace({
          search: queryParams.toString(),
        });
      }
    }
  };
  const [
    _,
    userVoicemailsLoadable,
    _setRefetchToggleVoicemails,
  ] = makeApiRequestCached(
    {
      endpoint: endpointEnum.GET_VOICEMAILS,
      domain: process.env.VITE_APP_API_DOMAIN,
      stage: 'itn',
      method: 'POST',
      payloadJsonString: JSON.stringify({
        userid: userAtomContents?.userid,
        apiKey: userAtomContents?.apikey,
        apikey: userAtomContents?.apikey,
        businessid: userAtomContents?.businessid,
        businessId: userAtomContents?.businessid,
        externalIds: JSON.stringify({ ids: externalIds }),
        call: 'getVoicemail',
        react: 1,
        superadmin: role === Role.SUPERADMIN,
      }),
    },
    (loadable, cached) => loadable.contents?.response?.data ?? cached.current
  );

  const sourceTypeMap = {
    CADENCE: 'cadences',
    'API-TO-QUEUE': 'queues',
    'API-QUEUE': 'queues',
    POWERDIALER: 'powerlists',
    CONFERENCE: 'conferences',
    'INCOMING-QUEUE': 'queues',
  } as const;

  const total = callHistory.contents?.data?.total ?? 0;

  const handlePageChange = (page: number, details?: any) => {
    // console.log("BEN Page Change", params);
    setPage(page);
  };

  const handlePageSizeChange = (pageSize: number, details?: any) => {
    setPageSize(pageSize);
  };

  const handleGridSortModelChange = (model: GridSortModel, details?: any) => {
    setGridSortModel(model);
  };

  const checkRecordingUrl = (call) => {
    let recordingurl = call?.recordingurl;
    const bus = businessDataLoadable?.contents?.response?.data?.result?.[0];
    const callUser = businessUsersLoadable?.contents?.response?.data?.result?.find(
      (u) => u?.userid === call?.calluserid
    );
    if (callUser && !callUser?.recordCalls) {
      recordingurl = '';
    }
    if (call.calltype === 'outgoing') {
      switch (bus?.blockOutboundCallRecordingSetting?.toLowerCase()) {
        case 'all':
          recordingurl = '';
          break;
        case 'twoparty':
          if (twoParty.includes(call?.outsidenumber?.substr(2, 3))) {
            recordingurl = '';
            break;
          }
      }
    }
    return recordingurl;
  };

  const getSourceDisplayName = (params) => {
    if (!params.row.source) return '';
    switch (params.row.source) {
      case 'C2C':
      case 'API':
        return params.row.source;
      case 'API-CALL':
        return 'API Call';
      case 'API-TO-QUEUE':
        return 'API to Queue';
      case 'POWERDIALER':
        return 'PowerDialer';
      case 'INCOMING-LOCALPRESENCE':
        return 'Incoming ConnectionBoost';
      case 'INCOMING-LOCALPRESENCE-LITE':
        return 'Incoming ConnectionBoost Pool';
      case 'AIO':
        return 'MaestroAI';
      default:
        const sourceWords = params.row.source.split(/[ -]/);

        for (let i = 0; i < sourceWords.length; i++) {
          sourceWords[i] =
            sourceWords[i][0].toUpperCase() +
            sourceWords[i].substr(1).toLowerCase();
        }
        return sourceWords.join(' ');
    }
  };

  const getSourceIdLink = (params) => {
    if (
      (permissionsLoadable.contents as IPermissions)?.role === Role.USER &&
      params.row.sourceid &&
      params.row.source
    ) {
      return `${params.row.sourcename}`;
    } else if (params.row.sourceid && params.row.source) {
      const sourcetype = sourceTypeMap[params.row.source];
      const sourceurl = `/manage/${sourcetype}/${params.row.sourceid}/edit`;
      return (
        <Tooltip title="Click To View Source">
          <Link to={sourceurl}>{params.row.sourcename}</Link>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title="ID Not Available/Applicable">
          <span>{'N/A'}</span>
        </Tooltip>
      );
    }
  };

  const isCallTranscriptionsFeaturedEnabled =
    process.env.VITE_APP_FEATURE_CALL_TRANSCRIPTIONS === '1' &&
    isBusinessEligibleToAccessCallTranscriptions === true;

  const canAccessCallTranscriptionProduct = canAccessCallTranscriptionPd(role);

  const isNotVoicemail = (params: GridRenderCellParams): boolean =>
    params.row.voicemail === undefined ||
    params.row.voicemail === null ||
    JSON.stringify(params.row.voicemail) === '{}';

  const isCompletedTranscription = (params: GridRenderCellParams): boolean =>
    params.row.transcriptionStatus === 'completed';

  const isMyProfileCallHistoryPage = window.location.pathname.startsWith(
    '/my-profile/'
  );

  const hasShowCallRecordingsEnabled =
    userAtomContents?.settings?.othersCanViewRecordings == '1';

  const hasAnyAgentWithCallTranscriptionProduct: boolean = useMemo(() => {
    return (businessUsersLoadable.contents?.response?.data?.result ?? []).some(
      (user: any) => user.hasPdCallTranscription === 1
    );
  }, [businessUsersLoadable]);

  const isScoreColumnVisible =
    isCallTranscriptionsFeaturedEnabled &&
    ((!isMyProfileCallHistoryPage && hasAnyAgentWithCallTranscriptionProduct) ||
      (isMyProfileCallHistoryPage && canAccessCallTranscriptionProduct));

  const rowsCached = useRef([]);
  /**
   * Transform by adding id
   * NOTE: must use useMemo so rows do not get updated on re-render
   */
  rowsCached.current = React.useMemo(
    () =>
      callHistory.state !== 'loading'
        ? callHistory.contents?.data?.calls?.map((row: any) => ({
            ...row,
            id: row.externalid,
            recordingurl: checkRecordingUrl(row),
            voicemail:
              row?.calltype === 'incoming' && row?.callstatus === 'missed'
                ? userVoicemailsLoadable?.contents?.response?.data?.voicemail?.find(
                    (v) => v?.externalcallid === row?.externalid
                  )
                : {},
            crmlink: row.crmlink ?? '',
          }))
        : rowsCached.current,
    [
      callHistory,
      businessDataLoadable,
      businessUsersLoadable,
      userVoicemailsLoadable,
    ]
  );
  const isCallDateValidForEventTrail = (params: GridRenderCellParams) => {
    //get call date (already in business time zone, just parse out)
    const callDate = new Date(
      params.row.phpcalldate2.match(/title='(.{1,})'/)?.[1]
    );

    //get current date (need to convert to business timezone)
    const currentDate = new Date(
      DateTime.fromMillis(Date.now(), {
        zone: businessDataCached.current?.timezone_php,
      }).toLocaleString(DateTime.DATETIME_SHORT)
    );

    //find the diff between the call date and the current date
    const dtDiff = Math.ceil(
      Math.abs(+currentDate - +callDate) / (1000 * 60 * 60 * 24)
    );
    // console.log(dtDiff)

    return dtDiff <= 14;
  };
  /**
   * Create cutom toolbar component for table
   * Use useCallback to stop rerendering
   */
  const ToolbarComponent = useCallback(
    (props: IToolbarComponent) => (
      <EnhancedTableToolbar
        {...props}
        search={search}
        setSearch={handleSearchChange}
        debounceTimeout={500} // add 1/2 second debounce vs 100ms default value
        isLoading={callHistory.state === 'loading'} // do not block on search
        dataType="Calls"
        csvExport={canDownloadHistoryBoolean}
        onCsvExport={(dataType, start, end, csvData) => {
          setCsvProps({
            dataType: dataType,
            start: start,
            end: end,
            csvData: csvData,
          });
          setShowExportModal(true);
        }}
        hideCsvExportButton={!canDownloadHistoryBoolean}
      />
    ),
    [search, callHistory, canDownloadHistoryBoolean]
  );
  const capitalize = (params) => {
    return params.value.charAt(0).toUpperCase() + params.value.slice(1);
  };
  const dispositionFormatter = (
    params: GridValueFormatterParams | GridRenderCellParams
  ) => {
    let disposition;
    switch (params.row.disposition) {
      case 'not disposed':
        disposition = 'No Call Outcome';
        break;
      case 'inbound VM-no msg left':
        disposition = 'No Voicemail Left';
        break;
      case 'inbound VM-msg left':
        disposition = 'Voicemail Left';
        break;
      default:
        return params.row.disposition;
    }
    return disposition;
  };

  /**
   * Create column for DataGrid renderer
   * use useMemo to prevent unneeded rerenderings
   */
  const columns = useMemo<IColDef[]>(
    () =>
      ([
        {
          field: '_event', // pseudo column
          headerName: 'Event',
          width: 65,
          disableExport: true,
          enableSorting: false,
          renderCell: (params: GridRenderCellParams) => {
            return params.row.calltype === 'incoming' ? (
              params.row.callstatus === 'answered' ? (
                <Tooltip title="Incoming Answered">
                  <CallReceived className={classes.callMadeIcon} />
                </Tooltip>
              ) : (
                <Tooltip title="Incoming Missed">
                  <CallMissedIcon className={classes.callMissedIcon} />
                </Tooltip>
              )
            ) : params.row.callstatus === 'answered' ? (
              <Tooltip title="Outgoing Answered">
                <CallMadeIcon className={classes.callMadeIcon} />
              </Tooltip>
            ) : (
              <Tooltip title="Outgoing Missed">
                <CallMissedOutgoingIcon className={classes.callMissedIcon} />
              </Tooltip>
            );
          },
        },
        {
          field: 'phpcallstring',
          headerName: 'Date',
          valueFormatter: (params: GridRenderCellParams) =>
            DateTime.fromMillis(+(params.value as string), {
              zone: businessDataCached.current?.timezone_php,
            }).toLocaleString(DateTime.DATETIME_SHORT),
          // moment(params.value).format('YYYY-MM-DD hh:mm:ss A'),
          headerClassName: classes.fullWidth,
          cellClassName: classes.fullWidth,
          minWidth: 104,
          maxWidth: 300,
        },
        {
          field: 'callid',
          headerName: 'Call ID',
          headerClassName: 'superStyle',
          hide: role !== Role.SUPERADMIN,
          disableExport: true,
        },
        {
          field: 'externalid',
          headerName: 'External ID',
          minWidth: 200,
          hide: role !== Role.SUPERADMIN,
          disableExport: true,
          headerClassName: classes.fullWidth + ' superStyle',
          cellClassName: classes.fullWidth,
          maxWidth: 500,
          renderCell: (params: GridRenderCellParams) => (
            <a
              href={`https://console.plivo.com/voice/logs/calls/stats/${
                params.value
              }/?end_date=${moment(
                +(params.row.phpcallstring as string)
              ).format('MM/DD/YYYY')}&subaccount=SANZVLNGY4NDFHYMZHMJ`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {params.value}
            </a>
          ),
        },
        {
          field: 'fname',
          headerName: 'Agent First Name',
          headerClassName: clsx(classes.typeColumn, classes.fullWidth),
          cellClassName: clsx(classes.typeColumn, classes.fullWidth),
          minWidth: 115,
          maxWidth: 150,
          hide: true,
        },
        {
          field: 'lname',
          headerName: 'Agent Last Name',
          headerClassName: clsx(classes.typeColumn, classes.fullWidth),
          cellClassName: clsx(classes.typeColumn, classes.fullWidth),
          minWidth: 115,
          maxWidth: 150,
          hide: true,
        },
        isScoreColumnVisible
          ? {
              field: 'transcriptionStrength',
              headerName: 'Score',
              headerClassName: clsx(classes.typeColumn, classes.fullWidth),
              cellClassName: clsx(classes.typeColumn, classes.fullWidth),
              minWidth: 115,
              maxWidth: 150,
            }
          : undefined,
        {
          field: 'calltype',
          headerName: 'Type',
          headerClassName: clsx(classes.typeColumn, classes.fullWidth),
          cellClassName: clsx(classes.typeColumn, classes.fullWidth),
          minWidth: 115,
          maxWidth: 150,
          renderCell: capitalize,
          valueFormatter: capitalize,
        },
        {
          field: 'source',
          headerName: 'Source',
          headerClassName: clsx(classes.typeColumn, classes.fullWidth),
          cellClassName: clsx(classes.typeColumn, classes.fullWidth),
          minWidth: 115,
          maxWidth: 150,
          renderCell: getSourceDisplayName,
        },
        {
          field: 'sourcename',
          headerName: 'Source Link',
          headerClassName: clsx(classes.typeColumn, classes.fullWidth),
          cellClassName: clsx(classes.typeColumn, classes.fullWidth),
          minWidth: 115,
          maxWidth: 150,
          renderCell: getSourceIdLink,
        },
        {
          field: 'callstatus',
          headerName: 'Status',
          headerClassName: clsx(classes.typeColumn, classes.fullWidth),
          cellClassName: clsx(classes.typeColumn, classes.fullWidth),
          minWidth: 115,
          maxWidth: 150,
          renderCell: capitalize,
          valueFormatter: capitalize,
        },
        {
          field: 'disposition',
          headerName: 'Call Outcome',
          headerClassName: classes.fullWidth,
          cellClassName: classes.fullWidth,
          minWidth: 150,
          maxWidth: 300,
          valueFormatter: dispositionFormatter,
          renderCell: dispositionFormatter,
        },
        // {
        //   field: 'durationMinutes',
        //   headerName: 'Duration',
        //   headerClassName: classes.fullWidth,
        //   cellClassName: classes.fullWidth,
        //   minWidth: 80,
        //   maxWidth: 100,
        //   valueFormatter: (params: GridValueFormatterParams) =>
        //     minutesDecimalFormatter(params.value?.toString()),
        //   renderCell: (params: GridRenderCellParams) => (
        //     <span data-pup={`row-${params.rowIndex}-duration`}>
        //       {minutesDecimalFormatter(params.value?.toString())}
        //     </span>
        //   ),
        // },
        {
          field: 'duration',
          headerName: 'Duration',
          headerClassName: classes.fullWidth,
          cellClassName: classes.fullWidth,
          minWidth: 80,
          maxWidth: 100,
          valueFormatter: (params: GridValueFormatterParams) =>
            secondsDecimalFormatter(params.value?.toString()),
          renderCell: (params: GridRenderCellParams) => (
            <span data-pup={`row-${params.id}-duration`}>
              {secondsDecimalFormatter(params.value?.toString())}
            </span>
          ),
        },
        {
          field: 'inside',
          headerName: 'Internal Call ID',
          renderCell: renderCell,
          headerClassName: classes.fullWidth,
          cellClassName: clsx(classes.fullWidth, classes.phoneNumber),
          minWidth: 250,
          maxWidth: 500,
        },
        {
          field: 'outside',
          headerName: 'External Contact',
          renderCell: renderCell,
          headerClassName: classes.fullWidth,
          cellClassName: clsx(classes.fullWidth, classes.phoneNumber),
          minWidth: 250,
          maxWidth: 500,
        },
        {
          field: 'amount',
          headerName: 'Amount',
          cellClassName: classes.fullWidth,
          headerClassName: classes.fullWidth,
          minWidth: 80,
          maxWidth: 150,
          renderCell: (params: GridRenderCellParams) => (
            <div>
              {Number(params?.value) % 1 !== 0
                ? Number(params?.value).toFixed(4)
                : Number(params?.value)}
            </div>
          ),
        },
        {
          field: 'pcActions',
          headerName: 'Actions',
          enableSorting: false,
          width: 150,
          headerAlign: 'center',
          align: 'center',
          disableExport: true,
          renderCell: (params: GridRenderCellParams) => (
            <PopupState variant="popover">
              {(popupState) => (
                <>
                  <Tooltip title="View actions">
                    <IconButton {...bindTrigger(popupState)} size="large">
                      <KeyboardArrowDownIcon />
                    </IconButton>
                  </Tooltip>
                  <Menu {...bindMenu(popupState)} disableScrollLock={true}>
                    {params.row.voicemail?.voicemailid &&
                      params.row.voicemail?.messagemp3 && (
                        <MenuItem
                          aria-label="report"
                          onClick={(e) => {
                            e.preventDefault();
                            popupState.close();
                            handleOpenVoicemailModal();
                            setVoicemailInfo({
                              agent: params.row.insidename,
                              recordingUrl: params.row.voicemail?.messagemp3,
                              callId: params.row.callid,
                              callType: params.row.calltype,
                              callDate: params.row.phpcalldate2.slice(
                                params.row.phpcalldate2.indexOf('>') + 1,
                                params.row.phpcalldate2.lastIndexOf('<')
                              ),
                              callXd: params.row.externalid,
                            });
                          }}
                          className={classes.dropdownButton}
                        >
                          <VoicemailIcon />
                          <small style={{ marginLeft: 7 }}>
                            Play Voicemail
                          </small>
                        </MenuItem>
                      )}
                    {isMyProfileCallHistoryPage &&
                    !hasShowCallRecordingsEnabled ? (
                      <></>
                    ) : (
                      isCallTranscriptionsFeaturedEnabled &&
                      canAccessCallTranscriptionProduct &&
                      isNotVoicemail(params) &&
                      isCompletedTranscription(params) && (
                        <MenuItem
                          aria-label="report"
                          onClick={(e) => {
                            e.preventDefault();
                            popupState.close();
                            setCallType(params.row.calltype);
                            setCallXd(params.row.externalid);
                            setCallDate(
                              params.row.phpcalldate2.slice(
                                params.row.phpcalldate2.indexOf('>') + 1,
                                params.row.phpcalldate2.lastIndexOf('<')
                              )
                            );
                            setTranscriptionUrl(params.row.recordingurl);
                            handleOpenCallTranscriptionModal();
                          }}
                          className={classes.dropdownButton}
                        >
                          <GraphicEq />
                          <small style={{ marginLeft: 7 }}>
                            Conversation Intelligence
                          </small>
                        </MenuItem>
                      )
                    )}
                    {params.row.crmlink &&
                      Number(params.row.duration ?? 0) > 0 && (
                        <a
                          href={params.row.crmlink}
                          aria-label="call"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            popupState.close();
                          }}
                        >
                          <MenuItem className={classes.dropdownButton}>
                            <img
                              src={CrmIcon}
                              style={{ display: 'inline-block', width: '28px' }}
                              alt="crm icon"
                            />
                            <small style={{ marginLeft: 7 }}>Go to CRM</small>
                          </MenuItem>
                        </a>
                      )}
                    {isMyProfileCallHistoryPage &&
                    businessUsersLoadable.contents?.response?.data?.result?.find(
                      (user: any) => +user?.userid === +params.row.calluserid
                    )?.othersCanViewRecordings !== 1 ? (
                      <></>
                    ) : (
                      params.row.recordingurl &&
                      (parseFloat(params.row.durationMinutes) || 0) > 0 &&
                      callRecord && (
                        <MenuItem
                          aria-label="call"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.preventDefault();
                            popupState.close();
                            handleOpenRecordingModal();
                            setRecordingInfo({
                              agent: params.row.insidename,
                              recordingUrl: params.row.recordingurl,
                              callId: params.row.callid,
                              callType: params.row.calltype,
                              callDate: params.row.phpcalldate2.slice(
                                params.row.phpcalldate2.indexOf('>') + 1,
                                params.row.phpcalldate2.lastIndexOf('<')
                              ),
                            });
                          }}
                          className={classes.dropdownButton}
                        >
                          <PlayCircleOutlineOutlinedIcon
                            className={classes.playIcon}
                          />
                          <small style={{ marginLeft: 7 }}>Play Audio</small>
                        </MenuItem>
                      )
                    )}
                    <MenuItem
                      onClick={(event) => {
                        event.preventDefault();
                        popupState.close();
                        handleClickSendSMS(
                          event,
                          `${location.pathname}/threaded-sms/${params.row.userid}/${params.row.phonenumber}`
                        );
                      }}
                    >
                      <NavLink
                        style={{ padding: 0 }}
                        className={classes.dropdownButton}
                        data-userid={params.row.calluserid}
                        data-businessid={params.row.businessid}
                        data-number={params.row.outsidenumber}
                        to={`${location.pathname}/threaded-sms/${params.row.calluserid}/${params.row.outsidenumber}`}
                      >
                        {tier !== 'Basic' && (
                          <>
                            <MessageIcon className={classes.messageIcon} />
                            <small style={{ marginLeft: 7 }}>Send SMS</small>
                          </>
                        )}
                      </NavLink>
                    </MenuItem>
                    {
                      //  ENG-5601: Event Trail Modal (FE)
                      //  if this call's date is <= 14 days, display the event trail icon because we should have that data
                      isCallDateValidForEventTrail(params) && (
                        <MenuItem
                          onClick={(e) => {
                            e.preventDefault();
                            popupState.close();
                            setCallId(params.row.callid);
                            setCallXd(params.row.externalid);
                            setCallConfId(params.row.conferenceName);
                            handleOpenEventTrailModal();
                          }}
                        >
                          <NavLink
                            style={{ padding: 0 }}
                            className={classes.dropdownButton}
                            to={`${location.pathname}`}
                          >
                            <HistoryOutlineOutlinedIcon
                              className={classes.auditTrail}
                            />
                            <small style={{ marginLeft: 7 }}>Event Trail</small>
                          </NavLink>
                        </MenuItem>
                      )
                    }
                  </Menu>
                </>
              )}
            </PopupState>
          ),
        },
      ] as IColDef[]).filter((colDef) => !!colDef) as IColDef[],
    [
      classes,
      businessUsersLoadable,
      role,
      callRecord,
      businessDataLoadable,
      userVoicemailsLoadable,
      setCallXd,
      setCallConfId,
    ]
  );
  // alert user on BasePage.tsx that table is capped at 10k rows
  useEffect(() => {
    if (total > 10_000) {
      dispatch(updateDisplayLargeTableMsg(true));
    }
  }, [rowsCached.current]);

  return (
    <>
      <DataTable
        rows={rowsCached?.current ?? []}
        columns={columns}
        rowCount={total > 10_000 ? 10_000 : total}
        displayCount={total}
        page={page}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        paginationMode="server"
        sortingMode="server"
        sortModel={sortModel}
        onSortModelChange={handleGridSortModelChange}
        loading={callHistory.state === 'loading'}
        ToolbarComponent={ToolbarComponent}
        pagination
      />
      <ModalWithStyles
        show={openRecordingModal}
        onHide={handleCloseRecordingModal}
        title="Call Audio"
        size="xs"
        submitLabel=""
      >
        <Box className={classes.audioContainer}>
          <div className={classes.audioDetails}>
            <p className={classes.audioBullet}>
              Agent: <strong>{recordingInfo.agent}</strong>
            </p>
            <p className={classes.audioBullet}>
              Call ID: <strong>{recordingInfo.callId}</strong>
            </p>
            <p className={classes.audioBullet}>
              Call Type: <strong>{recordingInfo.callType}</strong>
            </p>
            <p className={classes.audioBullet}>
              Date: <strong>{recordingInfo.callDate}</strong>
            </p>
          </div>
          <audio
            controls
            src={recordingInfo.recordingUrl}
            className={classes.audio}
          >
            Your browser does not support the audio element.
          </audio>
        </Box>
      </ModalWithStyles>
      <VoicemailModal
        openVoicemailModal={openVoicemailModal}
        handleCloseVoicemailModal={handleCloseVoicemailModal}
        classes={classes}
        voiceMailInfo={voiceMailInfo}
        businessId={userAtomContents?.businessid}
      />
      <HistoryExportModal
        show={showExportModal}
        handleClose={() => {
          setShowExportModal(false);
        }}
        page={page}
        pageSize={pageSize}
        totalRows={total}
        type={'call-history'}
        csvProps={csvProps}
        agentId={agentId}
        rows={rowsCached?.current ?? []}
        filters={{ search }}
        canDownloadHistoryBoolean={canDownloadHistoryBoolean}
      />
      <CallTranscriptionModal
        show={openCallTranscriptionModal}
        handleClose={() => {
          setOpenCallTranscriptionModal(false);
          dispatch(toggleIsPlaying(false));
          dispatch(updateMillisecond(0));
          resetLinkState();
        }}
        callXd={callXd}
        businessId={userAtomContents?.businessid}
        timezone={businessDataCached.current?.timezone_php}
        callDate={callDate}
        callType={callType}
        recordingUrl={transcriptionUrl}
      />
      {callXd !== '' ? ( //do not render without a specified callXd
        <EventTrailModal
          handleClose={() => {
            handleCloseEventTrailModal();
            setCallConfId('');
            setCallId('');
            setCallXd('');
          }}
          show={openEventTrailModal}
          objectType="call"
          businessId={userAtomContents?.businessid}
          internalCallId={callId}
          externalCallId={callXd}
          timezone={businessDataCached.current?.timezone_php || undefined}
          conferenceName={callConfId}
        />
      ) : (
        <></>
      )}
    </>
  );
};
